<template>
    <el-container>
        <el-header>
            <HeaderCom></HeaderCom>
        </el-header>
        <el-main class="center" :class="propClass">
            <slot></slot>
        </el-main>
    </el-container>

</template>

<script>
  import HeaderCom from './../components/headerCom'

  export default {
    name: "layout",
    components: {
      HeaderCom
    },
    props: ['propClass']
  }
</script>

<style scoped>
    .el-main {
        display: flex;
        flex: 1;
    }
    .el-main.verticalCenter {
        align-items: center;
    }
</style>
